export default "__VITE_ASSET__BO_gw_PV__"